var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"unalengua-logo depth",style:(_vm.style),on:{"click":_vm.navigateToMainSite}},[_c('span',[_vm._v("Unalengua")]),_vm._v(" "+_vm._s(_vm.$t('toolbar.ipa'))+" "+_vm._s(_vm.$t('toolbar.translator')))])
}
var staticRenderFns = []

export { render, staticRenderFns }